const isEnableSections = (level, levelToFilter = 'personal') => {
    return (
        level !== null &&
        level.hasOwnProperty('value') &&
        level.value !== levelToFilter
    )
}

const getSelectedLevel = (level, defaultLevelToShow = 'personal') => {
    return level !== null ? level.value : defaultLevelToShow
}

export { isEnableSections, getSelectedLevel }
